import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import { View, Text } from 'react-native';
import { withStyles } from '@material-ui/core/styles';
import { CustomFormGroup, CustomFormControl, selectStyles, selectDot } from 'root/libs/exaforte/react/Form';
import { CustomCheckBox } from 'root/libs/exaforte/react/Form';
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';
import CustomForm from 'root/libs/exaforte/react/form/CustomForm';
import { ContentDialog } from 'root/globals/Dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { faEngineWarning } from '@fortawesome/pro-regular-svg-icons';

import defaults from 'root/globals/Defaults.less';
import form from './Form.less';

const styles = {...defaults, ...form};

export const FieldSet           = withStyles({root: {
                                    '& .MuiInput-input, & input.rc-time-picker-input': {
                                        boxSizing: 'border-box',
                                        borderRadius: 4,
                                        borderColor: '#d8d8d8',
                                        fontSize: '14px !important',
                                        fontWeight: 300,
                                        '&:not(.MuiInput-inputMultiline):not([type="file"])': {
                                            height: 40
                                        },
                                        '&[type="file"]':{
                                            height: '100%'
                                        },
                                        '@media only screen and (max-width: 575px)': {
                                            borderRadius: 2.8
                                        }
                                    },
                                    '& .MuiInputLabel-root[data-mandatory=true]:not(.Mui-focused)': {
                                        color: '#212529',
                                    },
                                    '& .Mui-checked': {
                                        '&:not(.Mui-disabled)'  : { color: '#3DBBE2 !important' },
                                        '&.Mui-disabled'        : { color: '#DDDDDD !important' },
                                    },
                                    '& .MuiFormLabel-root': {
                                        fontSize: 14,
                                    },
                                    '& .PrivateSwitchBase-root-307': {
                                        padding: '0 9px',
                                    },
                                }})(CustomFormControl);
export const FieldGroup         = withStyles({ root: {} })(CustomFormGroup); // root meesturen omdat er anders een error komt als je FieldGroup in een andere withStyles gebruikt.
export const customSelectStyles = {...selectStyles, ...{
    indicatorSeparator: (styles, state) => ({
        ...(selectStyles.indicatorSeparator ? selectStyles.indicatorSeparator(styles, state) : styles),
        display: 'none',
    }),
    
    control: (styles, state) => ({
        ...(selectStyles.control ? selectStyles.control(styles, state) : styles),
        minHeight: 40,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: (state.selectProps['data-error'] ? '#f44336' : '#d8d8d8'),
        borderRadius: 4,
        
        '@media only screen and (max-width: 575px)': {
            borderRadius: 2.8
        },
        
        '& > div:first-of-type': {
            fontSize: 14,
            fontWeight: 300
        }
    }),
    placeholder: (styles, state) => ({
        ...(selectStyles.placeholder ? selectStyles.placeholder(styles, state) : styles),
        fontSize: 14,
        fontWeight: 300,
        color: '#808080',
    }),
    dropdownIndicator: (styles, state) => ({
        ...(selectStyles.dropdownIndicator ? selectStyles.dropdownIndicator(styles, state) : styles),
        backgroundColor: 'transparent',
        padding: 3,
        marginRight: 8
    }),
    option: (styles, state) => ({
        ...(selectStyles.option ? selectStyles.option(styles, state) : styles),
        fontSize: 14,
        backgroundColor: state.isSelected ? '#3dbbe2' : '#fff',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#3dbbe2', color: '#fff'
        }
    })
}};
export const customSelectDot    = (color = '#ccc') => (_.merge(selectDot(color), {}));

const FieldSetCheckbox  =   withStyles({root: {
                                borderRadius: '2px',
                                width: 'auto',
                                
                                '&  .MuiIconButton-label': {
                                    height: 20,
                                    width: 20,  
                                },
                                '& .Mui-checked .MuiIconButton-label': {
                                    color: '#FBA004'
                                },
                                '& .MuiFormControl-root': {
                                    maxHeight: 20,
                                    maxWidth: 20, 
                                },
                            }})(FieldSet);
                            
export const CustomTextFieldWithArrowLeft = withStyles({root: {'& .MuiInput-formControl::before': {
            content: '""',
            position: 'absolute',
            top: 12,
            left: -12,
            borderStyle: 'solid',
            border: 13,
            borderLeft: 0,
            borderColor: 'transparent #d8d8d8',
            display: 'block',
            width: 0,
            zIndex: 0
        }, '& .MuiInput-formControl::after': {
            content: '""',
            position: 'absolute',
            top: 13,
            left: -11,
            borderStyle: 'solid',
            border: 12,
            borderLeft: 0,
            borderColor: 'transparent #F8F8F8',
            display: 'block',
            width: 0,
            zIndex: 0,
        }, '& .Mui-focused::before': {
            content: '""',
            position: 'absolute',
            top: 12,
            left: -12,
            borderStyle: 'solid',
            border: 13,
            borderLeft: 0,
            borderColor: 'transparent #3EBBE2',
            display: 'block',
            width: 0,
            zIndex: 0
        }, '& .Mui-focused::after': {
            content: '""',
            position: 'absolute',
            top: 13,
            left: -10,
            borderStyle: 'solid',
            border: 12,
            borderLeft: 0,
            borderColor: 'transparent #F8F8F8',
            display: 'block',
            width: 0,
            zIndex: 0,
        }, '& .MuiInput-input': {
            backgroundColor: '#F8F8F8',
        }}})(FieldSet);

export const CustomTextFieldWithArrowBottom = withStyles({root: {'& .MuiInput-formControl::before': {
            content: '""',
            position: 'absolute',
            bottom: -12,
            left: 12,
            borderStyle: 'solid',
            border: 13,
            borderBottom: 0,
            borderColor: '#d8d8d8 transparent',
            display: 'block',
            width: 0,
            zIndex: 0
        }, '& .MuiInput-formControl::after': {
            content: '""',
            position: 'absolute',
            bottom: -11,
            left: 13,
            borderStyle: 'solid',
            border: 12,
            borderBottom: 0,
            borderColor: '#F8F8F8 transparent',
            display: 'block',
            width: 0,
            zIndex: 0,
        }, '& .Mui-focused::before': {
            content: '""',
            position: 'absolute',
            bottom: -12,
            left: 12,
            borderStyle: 'solid',
            border: 13,
            borderBottom: 0,
            borderColor: '#3EBBE2 transparent',
            display: 'block',
            width: 0,
            zIndex: 0
        }, '& .Mui-focused::after': {
            content: '""',
            position: 'absolute',
            bottom: -10,
            left: 13,
            borderStyle: 'solid',
            border: 12,
            borderBottom: 0,
            borderColor: '#F8F8F8 transparent',
            display: 'block',
            width: 0,
            zIndex: 0,
        }, '& .MuiInput-input': {
            backgroundColor: '#F8F8F8',
        }}})(FieldSet);
        
export const CustomTextFieldWithArrowTop = withStyles({root: {'& .MuiInput-formControl::before': {
        content: '""',
        position: 'absolute',
        top: -12,
        left: 12,
        borderStyle: 'solid',
        border: 13,
        borderTop: 0,
        borderColor: '#d8d8d8 transparent',
        display: 'block',
        width: 0,
        zIndex: 0
        }, '& .MuiInput-formControl::after': {
        content: '""',
        position: 'absolute',
        top: -11,
        left: 13,
        borderStyle: 'solid',
        border: 12,
        borderTop: 0,
        borderColor: '#F8F8F8 transparent',
        display: 'block',
        width: 0,
        zIndex: 0,
        }, '& .Mui-focused::before': {
        content: '""',
        position: 'absolute',
        top: -12,
        left: 12,
        borderStyle: 'solid',
        border: 13,
        borderTop: 0,
        borderColor: '#3EBBE2 transparent',
        display: 'block',
        width: 0,
        zIndex: 0
        }, '& .Mui-focused::after': {
        content: '""',
        position: 'absolute',
        top: -10,
        left: 13,
        borderStyle: 'solid',
        border: 12,
        borderTop: 0,
        borderColor: '#F8F8F8 transparent',
        display: 'block',
        width: 0,
        zIndex: 0,
        }, '& .MuiInput-input': {
        backgroundColor: '#F8F8F8',
        }}})(FieldSet);

export class FormGroup extends React.Component {
    render() {
        const has_description = !_.is_empty(this.props.group_description);
        
        return (
            <View className={['col-12 col-md-' + this.props.cols + ' d-flex mb-' + this.props.cols, ...(this.props.className || [])]}>
                {this.props.index != null && (
                    <View className={[styles['mr-2']]}>
                        <Text className={[styles['f-1-2-5'], styles['border-radius-100'], styles['color-white'], styles['background-color-light-blue'], styles['form-number'], 'd-flex align-items-center justify-content-center']}>{this.props.index + 1}</Text>
                    </View>
                )}
                <View className={[styles['flex-1']]}>
                    {this.props.title && <Text className={[styles['f-1-7-5'], ...(has_description ? [] : ['mb-3'])]}>{this.props.title}</Text>}
                    {has_description && <Text className={[styles['f-1-5'], styles['text-light'], 'mb-4']}>{this.props.group_description}</Text>}
                    <CustomForm group={this.props.title} { ..._.omit(this.props, ['title', 'cols', 'index', 'group_description']) } />
                    {this.props.children}
                </View>
            </View>
        );
    }
}

FormGroup.defaultProps = {
    cols: 4
}

export class FormMessages extends React.Component {
    render() {
        return <>
            <FormErrors {...this.props} />
            <FormWarnings {...this.props} />
        </>;
    }
}

export class FormErrors extends React.Component {
    render() {
        let parent = this.props.controller;
        
        if(!parent)
            parent = this.props.model;
        
        if((!parent || !parent.has_errors()) && _.is_empty(this.props.errors))
            return null;
            
        return <View className={[styles['background-color-red-pink-10'], styles['color-red-pink'], 'd-flex flex-row p-3 mb-4']}>
            <FontAwesomeIcon icon={faEngineWarning} className={styles['f-3-5']} />
            <View className={['ml-2']}>
                <Text>{this.props.title}</Text>
                <View className={[styles['text-light']]}>
                    {_.map(this.props.errors || parent.get_errors({return_type: 'array'}), (error, index) => <Text key={'error-' + index}>• {error}</Text>)}
                </View>
            </View>
        </View>;
    }
}

FormErrors.defaultProps = {
    title: 'Oeps.. niet alle velden zijn goed ingevuld'
}

export class FormWarnings extends React.Component {
    renderWarning(warning, index) {
        return <Text key={'warning-' + index}>• {warning}</Text>;
    }
    
    render() {
        let parent = this.props.controller;
        let action = this.props.action;
        
        if(!parent)
            parent = this.props.model;
        
        if((!parent || !parent.has_warnings()) && _.is_empty(this.props.warnings))
            return null;
        
        if(parent && !this.props.action)
            action = (
                <label className={['d-flex flex-row align-items-center']}>
                    <CustomCheckBox value={parent.ignore_warnings ? 't' : 'f'} onChangeText={() => {parent.ignore_warnings = !parent.ignore_warnings;parent.direct_update()}} wrapper={FieldSetCheckbox} />
                    <Text className={['pl-1', styles['text-color-dark-black'], styles['text-light']]}>Negeer deze waarschuwing{_.size(parent.warnings) != 1 && 'en'}</Text>
                </label>
            );
        
        return <View className={[styles['background-color-yellow-10'], styles['color-orange'], 'd-flex flex-row p-3 mb-4']}>
            <FontAwesomeIcon icon={faEngineWarning} className={styles['f-3-5']} />
            <View className={['ml-2']}>
                <Text>{this.props.title}</Text>
                <View className={[styles['text-light']]}>
                    {_.map(this.props.warnings || parent.get_warnings({return_type: 'array'}), this.renderWarning)}
                </View>
                {action}
            </View>
        </View>;
    }
}

FormWarnings.defaultProps = {
    title: 'Let op!'
}

export class FormSuccess extends CustomComponent {
    render() {
        return (
            <View className={[styles['background-color-light-green-10'], styles['color-light-green'], 'd-flex flex-row p-3 mb-4']}>
                <FontAwesomeIcon icon={faCheck} className={styles['f-3-5']} />
                <View className={['ml-2']}>
                    <Text>{this.props.title}</Text>
                    <Text className={[styles['text-light']]}>{this.props.children}</Text>
                </View>
            </View>
        );
    }
}
FormSuccess.defaultProps = {
    title: 'Gelukt!'
}